import { TimeFilterOption } from '../components/pages/genericTransactionsHistory/interfaces/TimeFilterOption';
import moment from 'moment';

const pagination = {
  descendingOrder: 'descendingOrder',
  nextOrPrev: 'nextOrPrev',
  pageNo: 'pageNo',
  paginationParams: 'paginationParams',
  resultsPerPage: 'resultsPerPage',
};

const requestModelBankHistory = {
  ...pagination,
  hub_id: 'hubId',
  bank_deposit_date: {
    path: 'depositDate',
    fn: (value) => {
      return getDateValues(value);
    },
  },
  transaction_date: {
    path: 'transactionDate',
    fn: (value) => {
      return getDateValues(value);
    },
  },
  type: 'type',
};

const requestModelBmDashboard = {
  ...pagination,
  hubId: 'hubId',
  status: 'transactionType',
  source: 'cashSource',
  mode: 'type',
  workerIdList: {
    path: 'selectedRider',
    fn: (value: any) => (value || []).map((r: any) => r.key || r),
  },
  fromDate: 'FromDate',
  toDate: 'ToDate',
  employeeDetails: 'employeeDetails',
  consignmentNumbers: 'consignmentNumbers',
};
const requestModelRemittance = {
  ...pagination,
  timeFilters: (iteratee) => {
    return getTimeFiltersRemittance(iteratee);
  },
  customerIdList: {
    path: 'selectedCustomer',
    fn: (value: any) => (value || []).map((c: any) => c.key || c),
  },
};

const requestModelCarrierHistory = {
  ...pagination,
  hubId: 'hubId',
  transaction_date: {
    path: 'transactionDate',
    fn: (value) => {
      return getDateValues(value);
    },
  },
  bank_deposit_date: {
    path: 'depositDate',
    fn: (value) => {
      return getDateValues(value);
    },
  },
  courier_account_list: {
    path: 'selectedCarrierAccount',
    fn: (value: any) => (value || []).map((c: any) => c.key || c),
  },
  transaction_type: 'view_type',
};

const requestModelCarrierHistoryDownload = {
  transaction_date_start: {
    path: 'transactionDate',
    fn: (value) => {
      return getDateValuesDownload(value, 'startDate');
    },
  },
  transaction_date_end: {
    path: 'transactionDate',
    fn: (value) => {
      return getDateValuesDownload(value, 'endDate');
    },
  },
  bank_deposit_date_start: {
    path: 'depositDate',
    fn: (value) => {
      return getDateValuesDownload(value, 'startDate');
    },
  },
  bank_deposit_date_end: {
    path: 'depositDate',
    fn: (value) => {
      return getDateValuesDownload(value, 'endDate');
    },
  },
  courier_account_list: {
    path: 'selectedCarrierAccount',
    fn: (value: any) => (value || []).map((c: any) => c.key || c),
  },
};
const getDateValues = (dateObj) => {
  if (dateObj.startDate && dateObj.endDate) {
    return [dateObj.startDate, dateObj.endDate];
  }
  return [];
};

const getDateValuesDownload = (dateObj, type) => {
  return dateObj[type]
    ? moment(dateObj[type]).format('YYYY-MM-DD')
    : undefined;
};

const getDateObject = (date) => {
  return {
    fromDateString: moment(date.startDate).format('YYYY-MM-DD'),
    toDateString: moment(date.endDate).format('YYYY-MM-DD'),
    filterName: date.dateType,
  };
};

const getTimeFiltersRemittance = (iteratee) => {
  const arr: TimeFilterOption[] = [];
  if (iteratee?.depositDate?.startDate || iteratee?.depositDate?.endDate) {
    arr.push(getDateObject(iteratee.depositDate));
  }
  if (iteratee?.transactionDate?.startDate || iteratee?.transactionDate?.endDate) {
    arr.push(getDateObject(iteratee.transactionDate));
  }
  return arr;
};

export {
  requestModelBankHistory,
  requestModelRemittance,
  requestModelBmDashboard,
  requestModelCarrierHistory,
  requestModelCarrierHistoryDownload,
};
